var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4468)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4468",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 16V20M8 4V8M9 18H5M10 6H6M15 4L16.7528 8.44437C16.9407 8.92083 17.0347 9.15906 17.1786 9.35994C17.3061 9.538 17.462 9.69391 17.6401 9.82143C17.8409 9.9653 18.0792 10.0593 18.5556 10.2472L23 12L18.5556 13.7528C18.0792 13.9407 17.8409 14.0347 17.6401 14.1786C17.462 14.3061 17.3061 14.462 17.1786 14.6401C17.0347 14.8409 16.9407 15.0792 16.7528 15.5556L15 20L13.2472 15.5556C13.0593 15.0792 12.9653 14.8409 12.8214 14.6401C12.6939 14.462 12.538 14.3061 12.3599 14.1786C12.1591 14.0347 11.9208 13.9407 11.4444 13.7528L7 12L11.4444 10.2472C11.9208 10.0593 12.1591 9.9653 12.3599 9.82143C12.538 9.69391 12.6939 9.538 12.8214 9.35994C12.9653 9.15906 13.0593 8.92083 13.2472 8.44437L15 4Z",
    stroke: "#F09C3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4468",
    x: 0,
    y: 1,
    width: 28,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.611765 0 0 0 0 0.227451 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4468",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.1db7745aceade81db6a49c8f00e2a7e2.svg";
export { ForwardRef as ReactComponent };